import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"course-session\">{{outlet}}</div>\n", {
  moduleName: "ilios-common/templates/session.hbs"
});